import {
  ofType
} from 'redux-observable';

import {
  ajax
} from "rxjs/ajax";

import { of } from 'rxjs';

import {
  map,
  switchMap,
  catchError,
} from 'rxjs/operators';

import {
  FETCH_BOUNDARIES,
  FETCH_BOUNDARIES_ERROR,
  SET_BOUNDARIES,
} from '../constants';

function test(state$){

return ''
}


const boundaries = (action$, state$) => action$.pipe(
  ofType(FETCH_BOUNDARIES),
  switchMap(() => ajax({
      url: `${state$.value.auth.server}/locations?v=${
        process.env.REACT_APP_VERSION
      }${test(state$)}`,
      headers: {
        Authorization: state$.value.auth.token,
      },
      responseType: 'json',
      crossDomain: true,
    }).pipe(
      map(response => {
        return ({
          type: SET_BOUNDARIES,
          data: response.response,
        })
      }),
      catchError(error => of({
        type: FETCH_BOUNDARIES_ERROR,
        error,
      }))
    ))
);

export default boundaries;
